// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { sankeyLinkHorizontal } from 'd3-sankey';
import {
    ISankeyLinkData,
    ISankeyNodeData,
    SankeyLayoutLink,
    SankeyLayoutNode,
} from 'admin/failoverDomain/page/components/SummaryCards/useSankeyLayout';

const linkPath = sankeyLinkHorizontal<ISankeyNodeData, ISankeyLinkData>();

interface ITooltipPosition {
    x: number;
    y: number;
}

interface ISankeyLinkProps {
    link: SankeyLayoutLink;
    formatValue?: (v: number) => string;
    onTooltip: (pos: ITooltipPosition, text: string) => void;
    onHideTooltip: () => void;
}

export const SankeyLink: React.FC<ISankeyLinkProps> = ({
    link,
    formatValue,
    onTooltip,
    onHideTooltip,
}) => {
    const sourceNode = link.source as SankeyLayoutNode;
    const targetNode = link.target as SankeyLayoutNode;
    const bandColor = link.bandColor ?? sourceNode.color;
    const valueLabel = formatValue ? formatValue(link.value) : String(link.value);
    const tooltipText = `${sourceNode.label} → ${targetNode.label}: ${valueLabel}`;

    return (
        <path
            d={linkPath(link) ?? undefined}
            fill="none"
            stroke={bandColor}
            strokeWidth={Math.max(1, link.width ?? 0)}
            strokeOpacity={0.15}
            style={{ cursor: 'default' }}
            onMouseMove={(e) => onTooltip({ x: e.clientX, y: e.clientY }, tooltipText)}
            onMouseLeave={onHideTooltip}
        />
    );
};
